@switch (column.format) {
  @case ('Currency') {
    <div class="currency">
      <p currencyMask class="currency">
        {{ column.footer ?? 0 | currency }}
      </p>
    </div>
  }
  @case ('MinuteToHour') {
    <p [style]="column.style">
      {{ transformService.convertMinutesToTimeString(column.footer) }}
    </p>
  }
  @default {
    <p truncateText [maxLength]="column.maxChars" [more]="'Mais'" [less]="'Esconder'">
      {{ column.footer }}
    </p>
  }
}
